import {IForm} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {Icon} from "~/cabinet/vue/interface/icon/IconInterface";

export interface PlatformInterface {
    id: string;
    descr: string;
    subCategoryDescr?: string;
    isOAuth: boolean;
    parentId?: string;
    isAuthDescrManual: boolean;
    hasChildPlatform: boolean;
    isReadyToUse: boolean;
    notGuaranteedText?: string[];
    icon: Icon;
    color: string;
    chatConfigForm?: IForm;
    isAuthEditable: boolean;
    isNeedPrepareAuthSave: boolean;
    knowledgeBaseRegisterId?: string;
    knowledgeBaseArticleHistoryId?: string;
    emptyChildErrorDescr?: string;
    isCrmPlatformWithSendMessages: boolean;
    isPlatformWithUsers: boolean;
    isCustomExternalBotPlatform: boolean;
    isAvailableForFreeOnlineChat: boolean;
}

export const INTEGRATION_PLATFORM_TYPE_MESSENGER = "messenger";
export const INTEGRATION_PLATFORM_TYPE_CRM = "crm";
export const INTEGRATION_PLATFORM_TYPE_ANALYTIC = "analytic";
export const INTEGRATION_PLATFORM_TYPE_COPILOT = "copilot";
export const INTEGRATION_PLATFORM_TYPE_EXTERNAL_BOT = "externalBot";
export const INTEGRATION_PLATFORM_TYPE_TELEPHONY = "telephony";
export const INTEGRATION_PLATFORM_TYPE_TIP = "tip";
export const INTEGRATION_PLATFORM_TYPE_TASK = "task";
export const INTEGRATION_PLATFORM_TYPE_EXTERNAL_SENDER = "externalSender";

